import { render, staticRenderFns } from "./BottomMenuLayout.vue?vue&type=template&id=dd0defa4&scoped=true&"
import script from "./BottomMenuLayout.vue?vue&type=script&lang=js&"
export * from "./BottomMenuLayout.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenuLayout.vue?vue&type=style&index=0&id=dd0defa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0defa4",
  null
  
)

export default component.exports